import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ServiceTypeEnum } from 'app/models';
import { MenuMartEnum } from 'app/components/mart';

@Component({
    selector: 'mart-root',
    templateUrl: './mart-root.component.html',
    styleUrls: ['./mart-root.component.scss',
        '../../../../styles/sidebar.scss'
    ]
})
export class MartRootComponent implements OnInit {
    public menuItemList: MenuItem[] = [];
    public serviceTypeId!: ServiceTypeEnum;

    constructor() { }

    public menuEnum = MenuMartEnum;
    public activeMenu: MenuMartEnum = MenuMartEnum.Merchants;

    //MENU
    public element: HTMLElement | null = document.querySelector('.menu');
    public isMoving: boolean = false;
    public lastLink: HTMLElement | null = null;
    public levels: Array<any> = [];

    ngOnInit(): void {
        document.addEventListener('click', this.handlerDocumentClick.bind(this));
    }

    public clickMenu(menu: MenuMartEnum) {
        this.activeMenu = menu;
    }

    //MENU
    open(item: any, list: any) {
        this.isMoving = true;

        const transition = parseFloat(getComputedStyle(list).transitionDuration);

        const style = list.style;

        style.display = 'block';

        const height = list.offsetHeight;

        style.height = '0';

        list.classList.add('open');

        item.classList.add('open');

        setTimeout(() => {
            style.display = 'block';

            style.height = height + 'px';
        }, 10);

        setTimeout(() => {
            style.height = '';

            this.isMoving = false;
        }, transition * 1000);
    }

    close(item: any, list: any) {
        this.isMoving = true;

        const transition = parseFloat(getComputedStyle(list).transitionDuration);

        const style = list.style;

        list.classList.remove('open');

        item.classList.remove('open');

        style.height = list.offsetHeight + 'px';

        setTimeout(() => {
            style.height = '0';
        });

        setTimeout(() => {
            style.height = '';

            style.display = '';

            this.isMoving = false;
        }, transition * 1000);
    }

    getAllLists(element: any, onlyOpen = false) {
        let selector = '[data-menu="list"]';

        if (onlyOpen) {
            selector += '.open';
        }

        return element.querySelectorAll(selector);
    }

    addLevel(object: any) {
        this.levels.push(object);
    }

    removeLevel(index: any) {
        const levels = this.levels;

        const item = levels[index].item;

        const lists = [...this.getAllLists(item, true)];

        this.levels = levels.filter((level): any => {
            if (!lists.includes(level.list)) {
                return true;
            }

            this.close(level.item, level.list);
        });

        return index;
    }

    getLevelIndexListByKey(element: any, key = 'parentList') {
        return this.levels.findIndex(level => level[key] === element);
    }

    handlerDocumentClick({ target }: { target: any }): void {
        if (this.isMoving) {
            return;
        }

        const item = target.closest('.menu__item');

        if (!item) {
            return;
        }

        const list = item.querySelector('[data-menu="list"]');

        const parentList = target.closest('[data-menu="list"]');

        let index = this.getLevelIndexListByKey(parentList);

        if (!list) {
            if (index > -1) {
                this.removeLevel(index);
            }

            const link = target.closest('.menu__link');

            if (this.lastLink) {
                this.lastLink.classList.remove('active');
            }

            link.classList.add('active');

            this.lastLink = link;

            return;
        }

        if (list.classList.contains('open')) {
            index = this.getLevelIndexListByKey(list, 'list');

            this.removeLevel(index);

            return;
        }

        this.open(item, list);

        if (index > -1) {
            this.removeLevel(index);
        }

        this.addLevel({ parentList, item, list });
    }

}
